/**
 * Recursively flattens an object into dot-notation key-value pairs
 * @param obj - Object to flatten
 * @param prefix - Prefix for nested keys
 * @returns Array of flattened key-value pairs
 */
const flattenObject = (
  obj: Record<string, unknown>,
  prefix = '',
): Array<{ key: string; value: string }> => {
  const result: Array<{ key: string; value: string }> = []

  Object.entries(obj).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key

    if (value === null || value === undefined || value === '') {
      // Skip empty values
      return
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      // Recursively flatten nested objects
      const nested = flattenObject(value as Record<string, unknown>, fullKey)
      result.push(...nested)
    } else if (Array.isArray(value)) {
      // Convert arrays to individual entries
      value.forEach((item) => {
        const stringValue =
          typeof item === 'object' && item !== null ? JSON.stringify(item) : String(item)
        result.push({ key: fullKey, value: stringValue })
      })
    } else {
      // Primitive values
      result.push({ key: fullKey, value: String(value) })
    }
  })

  return result
}

export default flattenObject
